<template>
  <div>
    <textarea :id="id" v-model="content"></textarea>
  </div>
</template>

<script>
import tinymce from "tinymce/tinymce";
import axios from "axios";
import { getUploadToken } from "@/api/app";
// 这下面是tinymce的插件
import "tinymce/themes/silver/theme";
import "tinymce/plugins/image";
// import "tinymce/plugins/link";
// import "tinymce/plugins/code";
// import "tinymce/plugins/table";
// import "tinymce/plugins/lists";
// import "tinymce/plugins/contextmenu";
// import "tinymce/plugins/wordcount";
// import "tinymce/plugins/colorpicker";
// import "tinymce/plugins/textcolor";
import "tinymce/plugins/media";
import "tinymce/skins/ui/oxide/skin.css";
import "tinymce/icons/default";
// 这里写你自己存放语言包的路径
import "../../assets/public/tinymce/langs/zh_CN.js";
import "../../assets/public/tinymce/plugins/axupimgs/plugin.min.js";
import { Loading } from "element-ui";

let loadingInstance = null;

export default {
  name: "tinymce-textvue",
  props: {
    id: String,
    contentInit: Object,
  },
  data() {
    return {
      content: "",
      indusHeadId: "",
      domain: "https://upload-z2.qiniup.com",
      init: {
        selector: `#${this.id}`,
        language: "zh_CN",
        // skin_url: "tinymce/skins/ui/oxide-dark",
        skin_url: "tinymce/skins/ui/oxide",
        height: 500,
        help_tabs: ["shortcuts"],
        // 插件
        // eslint-disable-next-line
        plugins:
          "autoresize preview searchreplace autolink directionality visualblocks visualchars fullscreen image axupimgs link media template code codesample table charmap hr pagebreak nonbreaking anchor insertdatetime advlist lists wordcount textpattern help paste autosave indent2em lineheight",
        // 工具栏
        // eslint-disable-next-line
        toolbar:
          "myMaterial | code undo redo restoredraft | cut copy paste pastetext | forecolor backcolor bold italic underline strikethrough link anchor | alignleft aligncenter alignright alignjustify outdent indent lineheight indent2em | fullscreen | bullist numlist | styleselect fontselect fontsizeselect | blockquote subscript superscript removeformat | table image axupimgs media charmap hr pagebreak insertdatetime preview | help",
        // 隐藏tinymce的标识
        branding: false,
        video_template_callback: (data) =>
          `<video style="margin:0 auto;" width="100%" height="100%"${data.poster ? ` poster="${data.poster}"` : ""} controls="controls">\n` +
          `<source src="${data.source}"${data.sourcemime ? ` type="${data.sourcemime}"` : ""} />\n` +
          (data.altsource ? `<source src="${data.altsource}"${data.altsourcemime ? ` type="${data.altsourcemime}"` : ""} />\n` : "") +
          "</video>",

        setup: function (editor) {
          editor.on("ExecCommand", function (e) {
            if (e.command === "mceInsertContent") {
              setTimeout(function () {
                editor.selection.collapse(false);
              }, 0);
            }
          });
        },

        // 视频
        file_picker_callback: (callback, value, meta) => {
          const that = this;
          if (meta.filetype == "media") {
            let input = document.createElement("input"); //创建一个隐藏的input
            input.setAttribute("type", "file");
            input.onchange = function () {
              let file = this.files[0]; //选取第一个文件
              console.log("file", file);
              var fileSize = file.size / 1024 / 1024;

              // 设置视频文件大小限制（示例：不允许大于 60MB）
              var maxFileSize = 60;

              if (fileSize > maxFileSize) {
                // 超过限制，给予用户提示
                that.$message.warning(`视频文件大小超过限制，最大允许${maxFileSize}MB`);
                return;
              }

              var video = document.createElement("video");
              video.src = URL.createObjectURL(file);
              video.onloadedmetadata = function () {
                // var videoWidth = video.videoWidth;
                // var videoHeight = video.videoHeight;

                // 设置期望的视频宽高比（示例：4:3）
                // var expectedAspectRatio = 4 / 3;

                // // 计算视频的实际宽高比
                // var actualAspectRatio = videoWidth / videoHeight;

                // // 设置允许的宽高比误差
                // var allowedError = 0.1; // 10%

                // // 检查视频宽高比是否在允许误差范围内
                // if (Math.abs(actualAspectRatio - expectedAspectRatio) > allowedError) {
                //   // 宽高比不符合要求，给予用户提示
                //   that.$message.warning("视频宽高比不符合要求，请上传4:3的比例视频");
                //   return;
                // }

                const { name } = file;
                getUploadToken().then((res) => {
                  const codeRes = res.code;
                  if (codeRes === 0) {
                    const token = res.data;
                    const config = {
                      headers: { "Content-Type": "multipart/form-data" },
                    };
                    // 重命名要上传的文件
                    const keyname = `${new Date().getTime()}.${name.substring(name.lastIndexOf(".") + 1)}`;
                    const formdata = new FormData();
                    // formdata.append("file", blobInfo.blob());
                    formdata.append("file", file);
                    formdata.append("token", token);
                    formdata.append("key", keyname);

                    loadingInstance = Loading.service({
                      lock: true,
                      text: "上传中",
                      customClass: "seller-style",
                    });

                    // 获取到凭证之后再将文件上传到七牛云空间
                    axios
                      .post("https://upload-z2.qiniup.com", formdata, config)
                      .then((resSucess) => {
                        loadingInstance && loadingInstance.close();
                        callback(`${process.env.VUE_APP_IMGURL}${resSucess.data.key}`, { title: file.name }); //将url显示在弹框输入框中
                      })
                      .catch((resFail) => {
                        loadingInstance && loadingInstance.close();
                        this.$message.error(`上传失败:${resFail}，请联系管理员`);
                        console.log("resFail", resFail);
                        // failure(`error${resFail}`);
                      });
                  } else {
                    this.$message.error("上传失败，请联系管理员");
                    console.log(codeRes);
                  }
                });
              };
            };
            //触发点击
            input.click();
          }
          if (meta.filetype == "image") {
            let input = document.createElement("input"); //创建一个隐藏的input
            input.setAttribute("type", "file");
            input.onchange = function () {
              let file = this.files[0]; //选取第一个文件
              console.log("file", file);
              var fileSize = file.size / 1024 / 1024;

              // 设置视频文件大小限制（示例：不允许大于 3MB）
              var maxFileSize = 3;

              if (fileSize > maxFileSize) {
                // 超过限制，给予用户提示
                that.$message.warning(`图片大小超过限制，最大允许${maxFileSize}MB`);
                return;
              }

              const { name } = file;
              console.log("file", file);
              console.log("file", this.files);
              getUploadToken().then((res) => {
                const codeRes = res.code;
                if (codeRes === 0) {
                  const token = res.data;
                  const config = {
                    headers: { "Content-Type": "multipart/form-data" },
                  };
                  // 重命名要上传的文件
                  const keyname = `${new Date().getTime()}.${name.substring(name.lastIndexOf(".") + 1)}`;
                  const formdata = new FormData();
                  // formdata.append("file", blobInfo.blob());
                  formdata.append("file", file);
                  formdata.append("token", token);
                  formdata.append("key", keyname);

                  loadingInstance = Loading.service({
                    lock: true,
                    text: "上传中",
                    customClass: "seller-style",
                  });

                  // 获取到凭证之后再将文件上传到七牛云空间
                  axios
                    .post("https://upload-z2.qiniup.com", formdata, config)
                    .then((resSucess) => {
                      loadingInstance && loadingInstance.close();
                      callback(`${process.env.VUE_APP_IMGURL}${resSucess.data.key}?imageView2/1/w/1920`, { title: file.name }); //将url显示在弹框输入框中
                    })
                    .catch((resFail) => {
                      loadingInstance && loadingInstance.close();
                      this.$message.error(`上传失败:${resFail}，请联系管理员`);
                      console.log("resFail", resFail);
                      // failure(`error${resFail}`);
                    });
                } else {
                  this.$message.error("上传失败，请联系管理员");
                  console.log(codeRes);
                }
              });
            };
            //触发点击
            input.click();
          }
        },

        // CONFIG: Paste
        paste_retain_style_properties: "all",
        //  word需要它
        paste_word_valid_elements: "*[*]",
        //  粘贴的同时能把内容里的图片自动上传，非常强力的功能
        paste_data_images: true,
        image_advtab: true,
        // images_upload_url: `https://nxincms.t.nxin.com/upload?type=1`,
        images_upload_handler(blobInfo, success, failure) {
          getUploadToken().then((res) => {
            const codeRes = res.code;
            if (codeRes === 0) {
              const token = res.data;
              const config = {
                headers: { "Content-Type": "multipart/form-data" },
              };
              let filetype = "";
              try {
                if (blobInfo.blob().type === "image/png") {
                  filetype = "png";
                } else {
                  filetype = "jpg";
                }
              } catch (e) {
                console.log(`获取上传文件类型异常信息${e}`);
              }
              // 重命名要上传的文件
              const keyname = `${new Date().getTime()}.${filetype}`;
              const formdata = new FormData();
              formdata.append("file", blobInfo.blob());
              formdata.append("token", token);
              formdata.append("key", keyname);
              // 获取到凭证之后再将文件上传到七牛云空间
              axios
                .post("https://upload-z2.qiniup.com", formdata, config)
                .then((resSucess) => {
                  // success(`//nfs.t.nxin.com/${resSucess.data.key}`);
                  success(`${process.env.VUE_APP_IMGURL}${resSucess.data.key}?imageView2/1/w/1920`);
                  // }
                })
                .catch((resFail) => {
                  failure(`error${resFail}`);
                });
            } else {
              this.$message.error("上传失败，请联系管理员");
              console.log(codeRes);
            }
          });
        },

        //  插入word文档需要该属性
        paste_convert_word_fake_lists: false,
        paste_webkit_styles: "all",
        paste_merge_formats: true,
        nonbreaking_force_tab: false,
        paste_auto_cleanup_on_paste: false,

        init_instance_callback: (editor) => {
          editor.on("paste", () => {
            setTimeout(() => {
              let content = tinymce
                .get(`${this.id}`)
                .getContent()
                .replace(/<img src="data:image\/(png|jpg|gif);base64,[^>]+>/i, "");
              tinymce.get(`${this.id}`).setContent(content);
              editor.selection.select(editor.getBody(), true);
              editor.selection.collapse(false);
            }, 0);
          });
        },

        // CONFIG: ContentStyle 这块很重要， 在最后呈现的页面也要写入这个基本样式保证前后一致， `table`和`img`的问题基本就靠这个来填坑了
        content_style: `
        *                         { padding:0; margin:0; }
        html, body                { height:100%; }
        img                       { max-width:100%; display:block;height:auto; }
        a                         { text-decoration: none; }
        iframe                    { width: 100%; }
        p                         { line-height:1.6; margin: 0px; }
        table                     {word-wrap:break-word;word-break:break-all;max-width:100%;border:none;}
        .mce-object-iframe        { width:100%; box-sizing:border-box; margin:0; padding:0; }
        ul,ol                     { list-style-position:inside; }
        .mce-offscreen-selection, .tox-lock.tox-button { display: none; }
`,

        insert_button_items: "image link | inserttable",

        // FontSelect
        // eslint-disable-next-line
        font_formats:
          "微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier;Georgia=georgia,palatino;Helvetica=helvetica;Impact=impact,chicago;Symbol=symbol;Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco;Times New Roman=times new roman,times;Verdana=verdana,geneva;Webdings=webdings;Wingdings=wingdings,zapf dingbats;知乎配置=BlinkMacSystemFont, Helvetica Neue, PingFang SC, Microsoft YaHei, Source Han Sans SC, Noto Sans CJK SC, WenQuanYi Micro Hei, sans-serif;小米配置=Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,Heiti SC,WenQuanYi Micro Hei,sans-serif",
      },
    };
  },
  methods: {
    // 把富文本的值传过去
    getMain() {
      // eslint-disable-next-line
      let content = tinymce.get(`${this.id}`).getContent();
      console.log(content);
      return content;
    },
    setMain(main) {
      console.log("main====", main);
      console.log("tinymce", tinymce.get(`${this.id}`));
      // main 是文本内容
      setTimeout(() => {
        tinymce.get(`${this.id}`).setContent(main);
      }, 500);
    },
  },

  mounted() {
    // 配置的初始化
    tinymce.init(this.init);
  },
  beforeDestroy() {
    // 销毁
    tinymce.get(this.id).setContent("");
    this.$nextTick(() => {
      tinymce.get(this.id).destroy();
    });
  },
  created() {},
};
</script>

<style lang="scss">
.tox-form__controls-h-stack {
  .tox-form__group:last-child {
    display: none;
  }
}
.tox .tox-dialog__body-nav,
.mce-offscreen-selection {
  display: none;
}
</style>
